import { GetBrandCategoryViewModel, GetCategoryBySlugViewModel } from '@/types/api'
import { TagViewModel } from '@/types/cml-api'

import { PLPBasicMetasProps, PLPPages, PurePLPBasicMetasProps } from '@/app/(plp)/types'

export function getGTMCategories(page: PLPPages, basicMetas: PLPBasicMetasProps): [string, string, string] {
    if (page === PLPPages.Categories || page === PLPPages.Combination) {
        const breadcrumb =
            page === PLPPages.Categories
                ? (basicMetas as GetCategoryBySlugViewModel).breadcrumb
                : (basicMetas as GetBrandCategoryViewModel)?.category?.breadcrumb

        switch (breadcrumb?.length) {
            case 1:
                return [breadcrumb[0].nameFa || '', '', breadcrumb[0].nameFa || '']
            case 2:
                return [breadcrumb[0].nameFa || '', breadcrumb[1].nameFa || '', breadcrumb[1].nameFa || '']
            case 3:
                return [breadcrumb[0].nameFa || '', breadcrumb[1].nameFa || '', breadcrumb[2].nameFa || '']
            default:
                return ['', '', '']
        }
    }
    if (page === PLPPages.Tags) {
        const slug = (basicMetas as TagViewModel).slug || ''

        return ['خانومی', slug, slug]
    } else {
        const slug = (basicMetas as PurePLPBasicMetasProps).nameFa || ''

        return ['خانومی', slug, slug]
    }
}
